import React from "react";
import { Box, Text, Flex } from "@chakra-ui/react";
import { InfoIcon } from "@chakra-ui/icons";

export const OldData = () => {
  return (
    <Box pb={4} textAlign="left" bg="white">
      <Flex mb={3} alignItems="center">
        <InfoIcon mr={2} />
        <Text fontWeight={600} color="gray.700">
          Experiencing Data Delays
        </Text>
      </Flex>
      <Text color="gray.600" fontSize="sm">Data displayed may not be up to date.</Text>
    </Box>
  );
};
